module.exports = __webpack_public_path__ + "img/MIMS_96dpi.cd31b700.png";